import React, { useCallback, useState } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker'
import styles from './datePickerWtn.module.scss'
import cx from 'classnames'
import ConfirmationControls from './ConfirmationControls'
import { DateSelection } from './types'

interface SinglePickerProps extends Omit<ReactDatePickerProps, 'onChange'> {
  setSelected: (date: DateSelection) => void
  btnCancelText?: string
  btnConfirmText?: string
  classInput?: string
  hideButtons?: boolean
}

const DatePickerWTN = ({
  selected,
  setSelected,
  btnCancelText,
  btnConfirmText,
  classInput = '',
  hideButtons = false,
  ...props
}: SinglePickerProps) => {
  const [picked, setPicked] = useState(selected)
  const [isOpen, setIsOpen] = useState(false)
  const handleCancel = useCallback(() => {
    if (isOpen) {
      setIsOpen(false)
      if (!hideButtons) setPicked(selected)
    }
  }, [selected, isOpen, hideButtons])

  const confirmSelection = useCallback(
    (selected: DateSelection) => {
      setSelected(selected)
      setPicked(selected)
      setIsOpen(false)
    },
    [setSelected]
  )

  const handleConfirm = useCallback(() => confirmSelection(picked), [confirmSelection, picked])

  const handleChange = useCallback(
    (date: DateSelection) => (hideButtons ? confirmSelection(date) : setPicked(date)),
    [confirmSelection, hideButtons]
  )

  return (
    <ReactDatePicker
      {...props}
      wrapperClassName={cx(props?.wrapperClassName)}
      className={cx(styles.commonDatePickerInput, classInput, {
        '--is-open': isOpen,
      })}
      popperClassName={cx(styles.pickerPopper, props?.popperClassName)}
      showPopperArrow={false}
      shouldCloseOnSelect={false}
      popperPlacement='bottom-start'
      onInputClick={() => setIsOpen(prev => !prev)}
      onChange={handleChange}
      onClickOutside={handleCancel}
      open={isOpen}
      selected={picked}
      dateFormat='d MMMM yyyy'
      readOnly
    >
      {!hideButtons && (
        <ConfirmationControls
          cancelBtn={{
            text: btnCancelText,
            onClick: handleCancel,
          }}
          confirmBtn={{
            text: btnConfirmText,
            onClick: handleConfirm,
          }}
        />
      )}
    </ReactDatePicker>
  )
}

export default DatePickerWTN
